import React, { PureComponent } from 'react';

import { Value } from './styled/SpeechRateStyled';

class SpeechRate extends PureComponent<{ value?: number }> {
    _getValue(value: number) {
        return Math.floor(value);
    }

    render() {
        const { value } = this.props;
        const safeValue = value ?? 0;
        return <Value>{this._getValue(safeValue)}</Value>;
    }
}

export default SpeechRate;
